import React from 'react';
import {
  Dialog,
  DialogContent,
  Typography,
  IconButton,
  Chip,
  Box
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const DiscountModal = ({ open, onClose, item }) => {
  if (!item) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      transitionDuration={{ enter: 200, exit: 150 }}
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: 6,
          backgroundColor: '#ffffff',
        },
      }}
      BackdropProps={{
        timeout: 200,
      }}
    >
      <DialogContent
        sx={{
          position: 'relative',
          padding: 3,
          borderLeft: 5,
          borderColor: item.color || '#ccc',
        }}
      >
        <IconButton
          onClick={onClose}
          size="small"
          sx={{ position: 'absolute', top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>

        <Typography variant="h6" fontWeight={600} gutterBottom>
          {item.title || 'Discount Info'} {item.rule_id ? ` - (Rule ID: ${item.rule_id})` : ''}
        </Typography>

        <Box mb={2}>
          <Typography variant="subtitle2" color="textSecondary">
            Status:
          </Typography>
          <Chip
            label={item.result || 'PASS'}
            color={item.result === 'FAIL' ? 'error' : 'success'}
            variant="filled"
            size="small"
            sx={{ mt: 0.5 }}
          />
        </Box>

        <Box mb={2}>
          <Typography variant="subtitle2" color="textSecondary">
            Needed Codes:
          </Typography>
          <Typography variant="body2" sx={{ wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>
            {item.codes_that_are_needed?.replace(/,/g, ', ') || '—'}
          </Typography>
        </Box>

        <Box mb={2}>
          <Typography variant="subtitle2" color="textSecondary">
            Codes to Check:
          </Typography>
          <Typography variant="body2" sx={{ wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>
            {item.codes_to_check_for?.replace(/,/g, ', ') || '—'}
          </Typography>
        </Box>

        <Box mb={2}>
          <Typography variant="subtitle2" color="textSecondary">
            Description:
          </Typography>
          <Typography variant="body2">
            {item.description || '—'}
          </Typography>
        </Box>

        <Box mb={3}>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                Financial Breakdown:
            </Typography>

            <Box
                sx={{
                border: '1px solid #ccc',
                borderRadius: 2,
                padding: 2,
                backgroundColor: '#fafafa',
                }}
            >
                <Box display="flex" justifyContent="space-between" gap={2} flexWrap="wrap">
                {[
                    { label: 'Gross Revenue', value: item.parent?.gross_revenue },
                    { label: 'Net Revenue', value: item.parent?.net_revenue },
                    { label: 'Discount', value: item.discountAmount },
                ].map((entry, index) => (
                    <Box key={index} flex="1 1 20%">
                    <Typography
                        sx={{
                        fontSize: '0.7rem',
                        fontWeight: 600,
                        letterSpacing: '0.04em',
                        color: '#455a64',
                        textTransform: 'uppercase',
                        mb: 0.5,
                        borderBottom: '1px solid #e0e0e0',
                        pb: 0.5,
                        }}
                    >
                        {entry.label}
                    </Typography>
                    <Typography
                        variant="body2"
                        fontWeight={entry.label === 'Discount' || entry.label === 'Discount %' ? 'bold' : 'normal'}
                    >
                        {typeof entry.value === 'number'
                        ? `$${entry.value.toFixed(2)}`
                        : entry.value}
                    </Typography>
                    </Box>
                ))}
                </Box>
            </Box>
        </Box>


        <Box mb={2}>
          <Typography variant="subtitle2" color="textSecondary">
            Invoice Item:
          </Typography>
          <Typography variant="body2">
            {item.parent?.invoiceitemid || '—'}
          </Typography>
        </Box>

        <Box mb={2}>
          <Typography variant="subtitle2" color="textSecondary">
            Date:
          </Typography>
          <Typography variant="body2">
            {item.parent?.datetime ? new Date(item.parent.datetime).toLocaleString() : '—'}
          </Typography>
        </Box>

        {item.tags?.length > 0 && (
          <Box mt={3} display="flex" gap={1} flexWrap="wrap" justifyContent="flex-end">
            {item.tags
              .sort((a, b) => (a.priority || 0) - (b.priority || 0))
              .map((tag, idx) => (
                <Chip
                  key={idx}
                  label={tag.title}
                  sx={{
                    backgroundColor: tag.color,
                    color: '#fff',
                    fontWeight: 500,
                    fontSize: '0.75rem',
                  }}
                />
              ))}
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default DiscountModal;
